var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecordTransactions = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.93 12.768a.663.663 0 1 1 0-1.326h5.784a.663.663 0 1 1 0 1.326zm0 2.892a.663.663 0 1 1 0-1.326h5.784a.663.663 0 1 1 0 1.326zm8.013-8.098h-.494a.663.663 0 0 1 0-1.325h1.156c.367 0 .663.296.663.663v11.567a.663.663 0 0 1-.663.663H7.038a.663.663 0 0 1-.663-.663V6.9c0-.367.297-.663.663-.663h1.157a.663.663 0 1 1 0 1.325H7.7v10.243h10.243zm-8.676-1.82c0-.365.297-.662.663-.662h5.784c.366 0 .662.297.662.663v3.47a.663.663 0 0 1-.662.663h-1.736a.663.663 0 0 1-.662-.663.494.494 0 1 0-.988 0 .663.663 0 0 1-.663.663H9.93a.663.663 0 0 1-.663-.663zm1.325.663V8.55h.534a1.82 1.82 0 0 1 3.39 0h.535V6.405z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecordTransactions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/record-transactions.1544087f.svg";